import {Navigate} from 'react-router-dom'
import {useAuth} from '../modules/auth'

const ProtectedSpecificRoute = ({children}) => {
  const {auth} = useAuth()

  if (auth?.data?.userType !== 'AUDITOR') {
    return children
  }
  return <Navigate to='/apps/plastic-credits/unaudited' replace />
}

export default ProtectedSpecificRoute

// userId
